const translation = {
    PageSize: 'Tamanho da página',
    PageOrientation: 'Orientação da página',
    Format: 'Formato',
    DPI: 'DPI',
    Title: 'Exportar mapa',
    Close: 'Fechar',
    Save: 'Salvar',
    FileName: 'Nome do arquivo',
    Landscape: 'Paisagem',
    Portrait: 'Retrato',
    PreviewHint: 'Ajuste a área a exportar no mapa.',
    ExportFailed: 'Falha ao exportar o mapa. Tente novamente.',
    PreviewFailed: 'Não foi possível gerar a pré-visualização.',
    AdjustArea: 'Ajustar área no mapa',
    AdjustAreaHint: 'Mova, aproxime, gire ou incline o mapa para enquadrar a área a exportar',
    ZoomIn: 'Ampliar',
    ZoomOut: 'Reduzir',
    ResetZoom: 'Redefinir o zoom para 100%',
    Done: 'Concluído',
    Cancel: 'Cancelar',
    Scalebar: 'Barra de escala',
    NorthIcon: 'Ícone do norte',
    ChooseNorthIcon: 'Escolher o ícone do norte',
    ChooseSvgFile: 'Escolher um ficheiro SVG',
    IconSymbol: 'Símbolo do ícone',
    IconColor: 'Cor do ícone',
    IconSize: 'Tamanho do ícone',
    InvalidSvg: 'O ficheiro não é um SVG válido.',
    ExportAsVector: 'Exportar como vetor',
    ExportLabelsAsVector: 'Exportar rótulos como vetor',
    Custom: 'Personalizado',
    Width: 'Largura',
    Height: 'Altura',
    LanguageName: 'Português',
    LanguageCode: 'pt'
};
export default translation;
